<template>
    <div class="account-view">
        <div class="account-view__content" v-if="isRequestingEmailChangeLink && !emailChangeSuccessful">
            <div class="account-view__section">
                <RouterLink to="/login" class="back-button">
                    <SvgIcon icon="icon--directional_arrow-left" class="is-primary-dark"/>
                    <span class="ml-2 has-text-primary-dark"> Zurück</span>
                </RouterLink>
                <div class="mb-4 login-form">
                    <h1 class="title is-3 has-text-grey">E-Mail Ändern</h1>
                    <transition nam="fade">
                        <p class="has-text-success is-size-4" v-if="isEmailChangeLinkSent && !emailChangeError">
                            Um Ihre neue E-Mail Adresse zu bestätigen haben wir eine E-Mail an Sie versendet. Bitte überprüfen Sie Ihr postfach.
                        </p>
                        <p class="has-text-danger is-size-4" v-if="emailChangeError">
                            Hier scheint ein Fehler aufgetreten zu sein.
                            Bitte bitte prüfen Sie ihre Mails oder versuchen Sie es zu einem späteren Zeitpunkt erneut.
                        </p>
                        <p class="has-text-danger is-size-4" v-if="emailChangeError">
                            Hier scheint ein Fehler aufgetreten zu sein.
                            Bitte bitte prüfen Sie ihre Mails oder versuchen Sie es zu einem späteren Zeitpunkt erneut.
                        </p>
                    </transition>
                </div>
            </div>
            <div class="account-view__section has-background-grey-lighter">
                <form class="login-form" @submit.prevent="changeEmail()">
                    <div class="columns is-multiline is-right">
                        <div class="column is-full">
                            <div class="field">
                                <label class="label is-uppercase mt-3 ml-3">E-Mail</label>
                                <div class="control">
                                    <input v-model="email" class="input" type="email" required
                                           placeholder="E-Mail">
                                </div>
                            </div>
                        </div>
                        <div class="column is-full login-form__actions">

                            <button :disabled="email.trim() === '' && !emailChangeError"
                                    :class="{'is-loading': processing}"
                                    class="button is-primary-dark px-6">{{ buttonText }}
                            </button>

                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="container has-text-left" v-if="emailChangeSuccessful">
            <div class="hero is-medium">
                <div class="hero-body">
                    <h1 class="title is-2 has-text-grey">Ihre E-Mail Adresse wurde erfolgreich geändert.</h1>
                </div>
            </div>
            <div class="container">
                <div class="section">
                    <router-link to="/start" class="is-size-3">Zurück zur Startseite</router-link>
                </div>
            </div>
        </div>
        <div class="container has-text-left" v-if="!emailChangeSuccessful && !isRequestingEmailChangeLink">
            <div class="hero is-medium">
                <div class="hero-body">
                    <h1 class="title is-2 has-text-grey">Ihre Code wurde bereits benutzt oder ist abgelaufen.</h1>
                </div>
            </div>
            <div class="container">
                <div class="section">
                    <router-link to="/start" class="is-size-3">Zurück zur Startseite</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import SvgIcon from "../svg/SvgIcon";

export default {
    name: "EMailChange",
    components: {SvgIcon},
    data() {
        return {
            userName: "",
            email: "",
            processing: false,
            isEmailChangeLinkSent: false,
            buttonText: "E-Mail ändern",
            emailChangePending: false,
            emailChangeCode: '',
            emailChangeError: false,
            isRequestingEmailChangeLink: true,
            emailChangeCodeError: false,
            emailChangeSuccessful: false,
        }
    },
    computed: {
        ...mapGetters(['']),
        isRequestingResetLink() {
            return !this.$route.query.cd;
        },
        passwordMessage() {
            if (this.emailChangePending) {
                return "Wird geändert..."
            }
            if (this.emailChangeSuccessful) {
                return "E-Mail wurde geändert."
            }
            return ""
        }
    },
    methods: {
        changeEmail() {
            this.passwordResetPending = true;
            this.$store.dispatch('changeEmail', {
                email: this.email
            }).then(() => {
                this.processing = false;
                this.emailChangeSuccessful = true;
            }).catch(() => {
                this.emailChangeSuccessful = false;
            })
        },
        fetchCMSData() {
            this.$store.dispatch('fetchCMSPage', {urlSlug: "/"});
        },
    },
    created() {
        this.fetchCMSData();
        if (!this.$store.getters.isUserLoggedIn) {
            this.$router.push('/login');
        }
    }
}
</script>

<style scoped>

</style>